if (!window.SaaltModal) {
window.SaaltModal = class SaaltModal extends HTMLElement {
  constructor() {
    super();
    this.modal = this;
    this.modalBtn = document.querySelector(this.dataset.modalButton);
    this.focusableElements = [];
    this.firstEl = null;
    this.lastEl = null;

    // bind once (avoid multiple listeners)
    this.handleKeydown = this.handleKeydown.bind(this);
    this.openPopup = this.openPopup.bind(this);
    this.handleClosePopup = this.handleClosePopup.bind(this);
  }

  connectedCallback() {
    this.setAttribute('role', 'dialog');
    this.setAttribute('aria-modal', 'true');
    this.setAttribute('aria-hidden', 'true');

    if (this.modalBtn) {
      this.modalBtn.addEventListener('click', this.openPopup);
    }

    this.addEventListener('click', this.handleClosePopup);
    window.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    window.removeEventListener('keydown', this.handleKeydown);
  }

  handleKeydown(e) {
    if (!this.classList.contains('reveal-modal')) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      this.handleClosePopup(e);
    }

    if (e.key === 'Tab') {
      this.trapFocus(e);
    }
  }

  openPopup(e) {
    if (!a11yClick(e)) return;

    this.classList.add('reveal-modal');
    this.setAttribute('aria-hidden', 'false');

    // Collect focusable elements
    this.focusableElements = this.querySelectorAll(
      'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
    );

    this.firstEl = this.focusableElements[0];
    this.lastEl = this.focusableElements[this.focusableElements.length - 1];

    // Focus first element safely
    if (this.firstEl) {
      this.firstEl.focus();
    } else {
      this.setAttribute('tabindex', '-1');
      this.focus();
    }
  }

  trapFocus(e) {
    if (!this.firstEl || !this.lastEl) return;

    if (e.shiftKey && document.activeElement === this.firstEl) {
      e.preventDefault();
      this.lastEl.focus();
    } else if (!e.shiftKey && document.activeElement === this.lastEl) {
      e.preventDefault();
      this.firstEl.focus();
    }
  }

  handleClosePopup(e) {
    const isEscape = e.key === 'Escape' || e.keyCode === 27;

    // allow only valid click or Escape
    if (!a11yClick(e) && !isEscape) return;

    // IMPORTANT FIX:
    // Only block click inside chart-wrapper — NOT Escape
    if (!isEscape && e.target.closest('.chart-wrapper')) return;

    this.classList.add('hide-modal');
    this.setAttribute('aria-hidden', 'true');

    setTimeout(() => {
      this.classList.remove('hide-modal', 'reveal-modal');
    }, 500);

    // return focus safely
    if (this.modalBtn) {
      this.modalBtn.focus();
    }
  }
};

customElements.define('saalt-modal', window.SaaltModal);
}